var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { OperationRecordsApi } from './apis/operation-records-api.interface';
import _ from 'lodash';
import { PatSnapAvatar } from '@/types/avatar';
let OperationRecordsRepositoryImpl = class OperationRecordsRepositoryImpl {
    constructor(_operationRecordsApi) {
        this._operationRecordsApi = _operationRecordsApi;
    }
    getOperationRecords(params) {
        return this._operationRecordsApi.getOperationRecords({
            space_id: params.spaceId,
            page: params.page,
            limit: params.pageSize,
            type: params.type,
        }).then((res) => {
            return {
                rows: this._formatOperationRecordsData(res.rows),
                page: res.page,
                pageSize: res.limit,
                total: res.total,
            };
        });
    }
    getSpecialQueryOriginalText(params) {
        return this._operationRecordsApi.getSpecialQueryOriginalText({
            type: params.queryType.toLocaleLowerCase(),
            id: params.queryId,
        }).then(res => {
            return res;
        });
    }
    _formatOperationRecordsData(list) {
        return _.map(list, (item) => {
            return {
                operationKey: item.operation_key,
                operationType: item.operation_type,
                operator: {
                    nickname: item.operator?.nickname,
                    email: item.operator?.email,
                    mobileNumber: item.operator?.mobile_number,
                    userId: item.operator?.user_id,
                    companyId: item.operator?.company_id,
                    companyName: item.operator?.company_name,
                    avatar: PatSnapAvatar.convertAvatar(item.operator),
                },
                operateTime: item.operate_time,
                operationParams: {
                    folderId: item.operation_params?.folder_id,
                    folderName: item.operation_params?.folder_name,
                    formFolderName: item.operation_params?.from_folder_name,
                    folderNameList: item.operation_params?.folder_name_list,
                    patentCount: item.operation_params?.patent_count,
                    receiverNameList: item.operation_params?.receiver_name_list,
                    receiverNameRoleList: item.operation_params?.receiver_name_role_list,
                    receiverRoleNameMap: item.operation_params?.receiver_role_name_map,
                    receiverIdList: item.operation_params?.receiver_id_list,
                    groupNameList: item.operation_params?.group_name_list,
                    comment: item.operation_params?.comment,
                    pn: item.operation_params?.patent_pn,
                    roleType: item.operation_params?.role,
                    displayQuery: item.operation_params?.display_query,
                },
            };
        });
    }
};
OperationRecordsRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(OperationRecordsApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof OperationRecordsApi !== "undefined" && OperationRecordsApi) === "function" ? _a : Object])
], OperationRecordsRepositoryImpl);
export { OperationRecordsRepositoryImpl };
